<!--  -->
<template>
  <div class="hotel-order">
    <div class="hotel-order-nav">
      <Nav
        :list="[...$optionsData.defaultAll, ...$optionsData.orderHotelMenuListSlice]"
        :activeValue.sync="activeValue"
        @on-success="onNavChange"
        class="nav-container"
      ></Nav>
    </div>
    <TablePage ref="list" @page-change="pageHandler" :total="total">
      <table>
        <tr class="t-header">
          <th class="t-g">客房信息 Room information</th>
          <th class="t-s">联系人 Contact person</th>
          <th class="t-m">金额 Amount</th>
          <th class="t-o">操作 Operation</th>
        </tr>
        <div v-for="item in orderList" :key="item.id" class="t-order">
          <tr class="t-order-info fl-align-center">
            <th class="primary-text" style="margin-left:30px">
              {{ item.orderTime }}
            </th>
            <th class="primary-text">订单编号 Order number：{{ item.orderNo }}</th>
            <th class="primary-text">
              {{ item.entityName }}
            </th>
            <th class="primary-text">
              {{ item.statusDesc }}
            </th>
          </tr>
          <tr class="t-order-content">
            <td class="t-g">
              <div class="goods-item">
                <div class="good-image">
                  <el-image :src="item.coverImage"></el-image>
                </div>
                <div class="good-info primary-text">
                  <p class="sl-ellipsis">{{ item.typeName }}</p>
                  <p class="sl-ellipsis">{{ item.typeNameEn }}</p>
                  <div class="good-spec">
                    <span>{{ item.specName }}</span>&nbsp;
                    <span>{{ item.specNameEn }}</span>
                  </div>
                  <div class="good-time">
                    <span>{{ item.startDate }}至{{ item.endDate }}</span
                    >&nbsp;
                    <span>{{ item.dayCount }}晚，</span>
                    <span>{{ item.qty }}间</span>
                  </div>
                  <div class="good-price">
                    ￥{{item.copeAmount}}
                  </div>
                </div>
              </div>
            </td>
            <td class="t-s">
              <!-- <p>{{item.}}</p> -->
              <el-popover width="400" trigger="hover" :disabled="item.takeType == 0">
                <div class="t-s-popover">
                  <span>{{ item.buyerName }}</span
                  >&nbsp;
                  <span>{{ item.buyerMobile }}</span>
                </div>
                <div class="">{{ item.summary }}</div>
                <div slot="reference" class="t-s-d">
                  <i class="el-icon-user"></i>
                </div>
              </el-popover>
            </td>
            <td class="t-m primary-text">
              <p>￥{{ item.payAmount }}</p>
              <p>分摊优惠：￥{{ item.goodsDecrAmount }}</p>
              <p>奖励金：￥{{ item.bonusDecrAmount }}</p>
            </td>
            <td class="t-o">
              <div class="order-btns">
                <template v-for="(btn, index) in item.btns">
                  <div
                    @click="handleClick(item, btn.funName)"
                    :class="['btn-item', btn.btnType == 'normal' ? 'normal-btn' : 'primary-btn']"
                    :key="index"
                  >
                    <div>
                      <p>{{ btn.chName }}</p>
                      <p>{{ btn.enName }}</p>
                    </div>
                  </div>
                </template>
                <div @click="handleClick(item, 'viewDetails')" :class="['btn-item', 'normal-btn']">
                  <div>
                    <p>查看详情</p>
                    <p>View Details</p>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </div>
      </table>
    </TablePage>
    <ShareDialog title="" v-if="shareVisible" :visible.sync="shareVisible" :shareImg="shareImg" />
  </div>
</template>

<script>
import Nav from "@/components/base/Nav.vue";
import TablePage from "@/components/base/TablePage";
import ShareDialog from "@/components/base/ShareDialog";
import PickUpCodeDialog from "./PickUpCodeDialog";
export default {
  name: "HotelOrder",
  components: { Nav, TablePage, ShareDialog, PickUpCodeDialog },
  props: {
    title: String,
  },
  data() {
    return {
      activeValue: -1,
      orderList: [],
      total: 0,
      orderStateOptions: [],
      shareVisible: false,
      shareImg: "",
    };
  },
  computed: {},
  mounted() {
    this.searchHandler();
    this.orderStateOptions = this.$_.cloneDeep(this.$optionsData.orderHotelStateOptions);
  },
  methods: {
    //初始化查询
    searchHandler() {
      this.$refs.list.reset();
    },
    onNavChange() {
      this.searchHandler();
    },
    async pageHandler(page, pageSize) {
      const params = {
        hotelOrderStatus: this.activeValue == -1 ? "" : this.activeValue,
        page: page,
        pageSize: pageSize,
      };
      try {
        let {
          data: { list, total },
        } = await this.$api.getUserlOrderList(params);
        this.orderList = list.map((item) => {
          item.btns = this.orderStateOptions[item.hotelOrderStatus].btns || [];
          return item;
        });
        this.total = total;
      } catch (error) {
        console.log(error);
      }
    },
    handleClick(item, funName) {
      this[funName](item);
    },
    //查看详情
    viewDetails(item) {
      this.$router.push(`/my-profile/order/hotel-detail?orderNo=${item.orderNo}`);
    },
    //取消订单
    cancelOrder(item) {
      this.$confirm("确定取消该订单？", "提示", {
        type: "warning",
        cancelButtonText: "再想想",
        confirmButtonText: "确定取消",
      })
        .then(async () => {
          try {
            await this.$api.cancelHotelOrder({
              orderNo: item.orderNo,
            });
            this.$message.success("取消成功");
            this.searchHandler();
          } catch (error) {
            console.log(error);
          }
        })
        .catch(() => {});
    },
    //去付款
    payGoods(item) {
      this.$router.push(`/home/pay-way?orderNo=${item.orderNo}&orderType=h`);
    },
  },
};
</script>
<style lang="scss" scoped>
.hotel-order {
  .hotel-order-nav {
    margin-top: 40px;
    /deep/.channel-nav-item {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      margin-right: 0 !important;
      flex: 1;
    }
  }
}
table {
  width: 100%;
  margin-top: 20px;
  .t-header {
    height: 50px;
    background: #fcfcfc;
    border: 1px solid #f0f0f0;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    > th {
      white-space: nowrap;
      flex: none;
    }
  }
  .t-g {
    width: 590px;
  }
  .t-s {
    width: 160px;
  }
  .t-m {
    width: 160px;
    border-right: 1px solid #f0f0f0;
    p {
      text-align: center;
      line-height: 1.5;
    }
  }
  .t-o {
    // width: 160px;
    text-align: center;
    flex: 1;
  }
  .t-order-info {
    height: 50px;
    background: #ffffff;
    border: 1px solid #f0f0f0;
    th {
      margin-left: 100px;
    }
  }
}

.t-order-content {
  background: #fcfcfc;
  display: flex;
  border-left: 1px solid #f0f0f0;
  border-right: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
  td {
    box-sizing: border-box;
  }
  .goods-item {
    display: flex;
    align-items: flex-start;
    padding: 30px;
    box-sizing: border-box;
    border: 1px solid #f0f0f0;
    border-bottom: 0;
    position: relative;
    .good-info {
      flex: 1;
      line-height: 1.3;
      p {
        width: 400px;
      }
      .good-spec {
        margin-top: 14px;
        font-size: 14px;
        
        font-weight: 400;
        color: #999999;
      }
      .good-time {
        margin-top: 10px;
      }
      .good-price {
        position: absolute;
        right: 24px;
        top: 24px;
      }
    }
    .good-image .el-image {
      width: 88px;
      height: 88px;
      display: block;
      margin-left: 32px;
      margin-right: 20px;
    }
  }
  .t-s {
    padding: 30px 20px 0;
    border-right: 1px solid #f0f0f0;
  }
  .t-m {
    padding-top: 30px;
  }
  .t-o {
    flex: 1;
    display: flex;
    justify-content: center;
    padding-top: 30px;
    .btn-item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 144px;
      height: 40px;
      cursor: pointer;
      margin-top: 2px;
      div {
        font-size: 14px;
        font-weight: 400;
        text-align: center;
      }
      &.normal-btn {
        background: #fff;
        color: #333333;
      }
      &.primary-btn {
        background: #333333;
        color: #ffffff;
      }
    }
  }
}
.t-order:last-child .t-g .goods-item:last-child {
  border-bottom: 1px solid #f0f0f0;
}
.t-s-d {
  display: flex;
  justify-content: center;
}
</style>
